import { robPersonQuery, useAxiosInstance, usePoQuery } from '@gov-nx/api';

export const useRobPersonQuery = () => {
	const { axiosInstance } = useAxiosInstance();
	const query = usePoQuery({
		queryKey: ['osoby', 'fyzicke'],
		queryFn: async () => robPersonQuery(axiosInstance),
	});

	/**
	 * `statniObcanstvi` muze mit tvary:
	 * - `203 Česká republika`
	 * - `203 Česká republika|804 Ukrajina`
	 * ...
	 */
	const isCzechCitizen = !!query.data?.statniObcanstvi
		?.split('|')
		.find((item) => item === '203 Česká republika');

	return {
		data: query.data,
		isLoading: query.isLoading,
		isError: query.isError,
		error: query.error,
		isCzechCitizen,
	};
};
